<template>
  <div class="beep">
    <img src="@/assets/promo/beep_promo.png" alt="Beep Beep Repeat" class="promo">
    <a href="https://www.amazon.com/Created-By-Intelligent-Design-Repeat/dp/B00BQ4RLSI/ref=sr_1_4?dchild=1&qid=1598738759&refinements=p_4%3ACreated+By+Intelligent+Design&s=mobile-apps&search-type=ss&sr=1-4">
      <img src="@/assets/buttons/amazon-kindlefire-white_badge.png" alt="">
    </a>
    <br><br>
    <h2>Follow the Light!</h2>
    <br>
    <p class="app-blurb">The classic game you know and love. Repeat the blinking pattern back every time or
      the game is over.</p>
    <p class="app-blurb">Will you be the champion? Challenge your friends and see!
    </p>
    <br><br>
    <img src="@/assets/screenshots/beep_01.png" alt="">
    <img src="@/assets/screenshots/beep_02.png" alt="">
    <img src="@/assets/screenshots/beep_03.png" alt="">
    <img src="@/assets/screenshots/beep_04.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'Beep',
  computed: {
    factor () {
      return window.innerWidth / 1280
    },
    embedHeight () {
      return {
        height: 566 * this.factor + 'px'
      }
    }
  }
}
</script>

<style scoped>
.beep {
  background-color: cornflowerblue;
  color: white;
  font-weight: 800;
  font-size: 1.2em;
}
.beep img {
  margin: 0 10px;
}
.promo {
  margin: 0 !important;
  width: 100%;
}

h2 {
  width: 80%;
  margin: auto;
}
iframe {
  width: 100%;
}
</style>
